import { useCallback, useContext } from 'react'

import _find from 'lodash/find'

import { Context } from '@/shared/store/reducers/global-reducer'
import { migratedImage } from '@/utils/migrated-image'

/**
 * Resolves a client's default project image from the clients already loaded in
 * the global store. Algolia records embed only the legacy field, so the store
 * is the source of truth for the migrated `*Cf` mirror.
 */
const useClientDefaultImage = () => {
  const { store } = useContext(Context)

  return useCallback(
    (clientId?: number): string | undefined =>
      migratedImage(
        _find(store.clients, (c: any) => c.id === clientId),
        'defaultProjectImage'
      ),
    [store.clients]
  )
}

export default useClientDefaultImage
